import { render, staticRenderFns } from "./SingleMessageDialog.vue?vue&type=template&id=40c78cdb&scoped=true&"
import script from "./SingleMessageDialog.vue?vue&type=script&lang=js&"
export * from "./SingleMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./SingleMessageDialog.vue?vue&type=style&index=0&id=40c78cdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c78cdb",
  null
  
)

export default component.exports